export default __webpack_public_path__ + "static/media/GHSI Succession and Remuneration Policy.520a7670.pdf";